module.exports = __webpack_public_path__ + "assets/img/thumb-The-Dream-Collective-Website.e1dc6bf7.jpg";